export default {"src":"/_next/static/media/icon_more_chat.0fa5b5ef.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};